import { auth } from '../../firebase';

type Mode = 'main' | 'arena';

type SelectTokenPayload = {
  leagueId: string;
  seasonId: string;
  tokenId: number;
  mode: Mode;
};

type SelectTokenResponse = {
  success: boolean;
  message: string;
};

const BASE_URL = process.env.REACT_APP_FFUNC_NET;

export const selectTokenRequest = async (
  payload: SelectTokenPayload,
): Promise<SelectTokenResponse> => {
  const user = auth.currentUser;

  if (!user) {
    return {
      success: false,
      message: 'Usuario no autenticado',
    };
  }

  const token = await user.getIdToken();

  const response = await fetch(`${BASE_URL}/selectToken`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  const data = await response.json();

  return {
    success: Boolean(data.success),
    message: String(data.message ?? 'Error desconocido'),
  };
};
